export var ExperimentId;
(function (ExperimentId) {
    ExperimentId["NEW_MOBILE_OIS_CTA_DESIGN"] = "NEW_MOBILE_OIS_CTA_DESIGN";
})(ExperimentId || (ExperimentId = {}));
// e.g. https://ab.sc-corp.net/v2/experiment/WEB_LENS_SEARCH_MOBILE
// WEB_LENS_SEARCH_MOBILE = "WEB_LENS_SEARCH_MOBILE",
